import React, { useState, useEffect, useMemo } from 'react';
import { ShopProvider } from '../../contexts/Shop'
import { HostProvider } from '../../contexts/Host'
import { CustomerProvider } from '../../contexts/Customer'
import { ProductsProvider } from '../../contexts/Products'
import FreeTrial from './FreeTrial'
import {AppProvider} from '@thinkwell/react.polaris';

export default function Index(props) {
  return (<AppProvider>
      <HostProvider value={props.host}>
      <ShopProvider value={props.shop_name}>
      <CustomerProvider value={props.customer}>
      <ProductsProvider value={props.products}>
      <FreeTrial skus={props.skus} />
    </ProductsProvider></CustomerProvider></ShopProvider></HostProvider></AppProvider>)
}
